export default {
  'viewTransferFileImport.heading': 'File Import Summary',
  'viewTransferFileImport.status.success': 'Success - File was processed successfully',
  'viewTransferFileImport.status.failed': 'Failed - File could not be processed'
};
